import { useState, useEffect, useCallback, useRef } from 'react'
import { MapContainer, Pane, Marker } from 'react-leaflet'
import L from 'leaflet';
import { useParams } from 'react-router-dom';
import useApi from '../utilities/useApi';
import arrayUtilities from '../utilities/arrayUtilities';
import stringUtilities from '../utilities/stringUtilities';
import roleUtilities from '../utilities/roleUtilities';
import Accordion from 'react-bootstrap/Accordion'
import SimpleBar from 'simplebar-react'
import 'simplebar/dist/simplebar.min.css'

import 'react-datepicker/dist/react-datepicker.css'

import RemoteControl from './map/remoteControl';
import postal from 'postal';
import Loading from './common/loading';
import Sketch from './map/sketch';
import DataPoint from './map/dataPoint';
import BufferOrdering from './map/bufferOrdering';
import { BUFFER_PANE, BUFFER_PANE_Z_INDEX } from '../utilities/constants';
import DataGeomtry from './map/dataGeometry';
import LimitsToolbox from './map/toolboxes/limitsToolbox';
import SketchesToolbox from './map/toolboxes/sketchesToolbox';
import FiltersToolbox from './map/toolboxes/filtersToolbox';
import DrawingToolsToolbox from './map/toolboxes/drawingToolsToolbox';
import SettingsToolbox from './map/toolboxes/settingsToolbox';
import MapOutputToolbox from './map/toolboxes/mapOutputToolbox';
import AddressSearchToolbox from './map/toolboxes/addressSearchToolbox';

import cloneDeep from 'lodash.clonedeep';
import StampsToolbox from './map/toolboxes/stampsToolbox';
import geospatialUtilities from '../utilities/geospatialUtilities';
import Basemap from './map/basemap';
import { Alert, Button, Form, OverlayTrigger, Popover, Modal, Offcanvas } from 'react-bootstrap';
import ReactSlider from 'react-slider';
import DownloadData from './map/exports/downloadData';
import DownloadMapPackage from './map/exports/downloadMapPackage';
import DownloadTelusReport from './map/exports/downloadTelusReport';
import DownloadOntarioLocateReport from './map/exports/downloadOntarioLocateReport';
import * as htmlToImage from 'html-to-image';
import moment from "moment";
import ConfigurationDialog from './map/drawingTools/_configurationDialog';
import { MoveData } from './common/formsCreateEdit/moveData';
import enums from '../utilities/enums';
import { KmlToolbox } from './map/toolboxes/kmlToolbox';
import KmlLayer from './map/kmlLayer';
import KmlPopup from './map/kmlPopup';
import WhenMapIsNotDrawingOrEditing from './map/whenMapIsNotDrawingOrEditing';
import { SurfacesToolbox } from './map/toolboxes/surfacesToolbox';
import DownloadsToolbox from './map/toolboxes/downloadsToolbox';
import { Surface } from './map/surface';
import ErrorModal from './common/errorModal';
var hash = require('object-hash');

export default function Map(props) {
    const MaxZoom = 25;
    const params = useParams();
    const mapRef = useRef(null);
    const tileLayerRef = useRef(null);

    const projectId = params.projectId;
    const organisationId = stringUtilities.isNullOrEmpty(params.organisationId) ? props.organisationId : params.organisationId;

    const { api } = useApi();

    const [isLoading, setIsLoading] = useState(true);
    const [points, setPoints] = useState(null);
    const [page, setPage] = useState(1);
    const [pointsHash, setPointsHash] = useState(null);
    const [hiddenDataPoints, setHiddenDataPoints] = useState(0);
    const [lines, setLines] = useState(null);
    const [project, setProject] = useState(null);

    const [jobs, setJobs] = useState(null);
    const [selectedJobs, setSelectedJobs] = useState([]);

    const [sketchData, setSketchData] = useState(null);

    const [dateFrom, setDateFrom] = useState(null);
    const [dateTo, setDateTo] = useState(null);

    const [sketches, setSketches] = useState(null);
    const [sketchId, setSketchId] = useState("");
    const [sketch, setSketch] = useState(null);
    const [sketchHash, setSketchHash] = useState(null);
    const [activeLimit, setActiveLimit] = useState(null);

    const [projects, setProjects] = useState(null);
    const [workflows, setWorkflows] = useState(null);
    const [workflowPoints, setWorkflowPoints] = useState([]);
    const [workflowLines, setWorkflowLines] = useState([]);
    const [workflowPointsLines, setWorkflowPointsLines] = useState([]);
    const [distinctFilteredWorkflows, setDistinctFilteredWorkflows] = useState(null);

    const [stamps, setStamps] = useState(null);
    const [tags, setTags] = useState(null);

    const [users, setUsers] = useState(null);
    const [selectedUsers, setSelectedUsers] = useState([]);
    const [includeDeleted, setIncludeDeleted] = useState(false);

    const [zoomLocked, setZoomLocked] = useState(false);
    const [zoom, setZoom] = useState(4);
    const [center, setCenter] = useState({
        lat: 48.166667,
        lng: -100.166667
    });
    const [bounds, setBounds] = useState(null);
    const [dataBounds, setDataBounds] = useState(null);
    const [showMapPackagePanel, setShowMapPackagePanel] = useState(false);
    const [isDownloadingScreenshot, setIsDownloadingScreenshot] = useState(false);
    const [isDownloadingData, setIsDownloadingData] = useState(null);
    const [isDownloadingTelusReport, setIsDownloadingTelusReport] = useState(false);
    const [isDownloadingOntarioLocateReport, setIsDownloadingOntarioLocateReport] = useState(false);
    const [downloadsRefreshKey, setDownloadsRefreshKey] = useState(0);
    const [snappingTolerance, setSnappingTolerance] = useState(0.5);
    const [arrowScale, setArrowScale] = useState(1);
    const [symbolScale, setSymbolScale] = useState(1);
    const [symbolDensity, setSymbolDensity] = useState(localStorage.getItem("symbolDensity") ?? 1);
    const [cpmDrawingOrder, setCpmDrawingOrder] = useState(localStorage.getItem("cpmDrawingOrder") !== "false");
    const [basemap, setBasemap] = useState(Number(localStorage.getItem("basemap") ?? 0));
    const [printBasemap, setPrintBasemap] = useState(Number(localStorage.getItem("printBasemap") ?? 0));
    const [mapOutputFormat, setMapOutputFormat] = useState(localStorage.getItem("mapOutputFormat") ?? enums.MapOutputFormat[0]);
    const [updateFeatureAttributesError, setUpdateFeatureAttributesError] = useState(null);
    const [isMultiTransferEnabled, setIsMultiTransferEnabled] = useState(false);
    const [showConfigurationDialog, setShowConfigurationDialog] = useState(false);
    const [kmlData, setKmlData] = useState([]);
    const [selectedKmlData, setSelectedKmlData] = useState([]);
    const [selectedKmlFeature, setSelectedKmlFeature] = useState(null);
    const isDrawingOrEditingRef = useRef(false);
    const [isSelectAllChecked, setIsSelectAllChecked] = useState(true);

    const [surfacesData, setSurfacesData] = useState([]);
    const [selectedSurfacesData, setSelectedSurfacesData] = useState([]);
    const [isSelectAllSurfacesChecked, setIsSelectAllSurfacesChecked] = useState(true);

    // Move Visible data states
    const [filteredWorkflows, setFilteredWorkflows] = useState(null)
    const [selectedProjectForMove, setSelectedProjectForMove] = useState(null);
    const [jobsForMove, setJobsForMove] = useState(null);
    const [selectedJobForMove, setSelectedJobForMove] = useState(null);
    const [workflowsForMove, setWorkflowsForMove] = useState(null);
    const [selectedWorkflowForMove, setSelectedWorkflowForMove] = useState(null);
    const [showJobModal, setShowJobModal] = useState(false);
    const [newJobName, setNewJobName] = useState("");
    const [isLoadingJobs, setIsLoadingJobs] = useState(false)
    const [isLoadingWorkflows, setIsLoadingWorkflows] = useState(false)
    const [transferEligiblePoints, setTransferEligiblePoints] = useState(null);

    const [connectionOriginalPoint, setConnectionOriginalPoint] = useState(null)
    const [connectionTargetPoint, setConnectionTargetPoint] = useState(null)
    const [isConnectingPoints, setIsConnectingPoints] = useState(false);
    const [connectionLineTypesOriginalPoint, setConnectionLineTypesOriginalPoint] = useState([])
    const [connectionLineTypesTargetPoint, setConnectionLineTypesTargetPoint] = useState([])
    const [selectedConnectionLineType, setSelectedConnectionLineType] = useState(null)

    const [errorMessage, setErrorMessage] = useState(null);
    
    const [showSketchSaveError, setShowSketchSaveError] = useState(false);
    const [sketchFromFailedSave, setSketchFromFailedSave] = useState(null);

    const onZoomChange = function (e) {
        setZoom(e);
    }

    const onAfterZoomChange = function (e) {

        setZoom(e);

        postal.publish({
            channel: "map",
            topic: "zoom.change",
            data: {
                zoom: e
            }
        });
    }

    const resetToLockedZoom = function () {
        if ((sketch.configuration?.zoom ?? 0) > 0) {
            setZoom(sketch.configuration.zoom);

            postal.publish({
                channel: "map",
                topic: "zoom.change",
                data: {
                    zoom: sketch.configuration.zoom
                }
            });
        }
    }

    const onAfterArrowScaleChange = function (arrowScale) {
        setArrowScale(arrowScale);

        if (sketch && sketch !== null) {
            onSaveSketch(sketch, true);
        }
    }

    const onBoundsChange = function (bounds, center) {
        setBounds(bounds);
        setCenter(center);
        if (!arrayUtilities.isNullOrEmpty(points)) {
            findTransferEligiblePoints(points, workflowPoints, workflowLines, workflowPointsLines, bounds)
        }
    }

    var _getDataAbortController = null;
    const getData = function (refresh, pageNumber, pages, basePointsArray) {
  
        if (pageNumber === undefined || pageNumber === null) {
            pageNumber = 1;
        }

        if (pages === undefined || pages === null) {
            pages = 1;
        }

        if (arrayUtilities.isNullOrEmpty(basePointsArray)) {
            basePointsArray = [];
        }

        if (refresh || (!dataBounds || dataBounds === null || (bounds && bounds !== null && !dataBounds.contains(bounds)) || hiddenDataPoints > 0)) {

            let theBounds = bounds && bounds !== null ? bounds : mapRef.current.getBounds();

            let n = theBounds.getNorth();
            let s = theBounds.getSouth();
            let e = theBounds.getEast();
            let w = theBounds.getWest();

            let width = geospatialUtilities.haversineDistance({
                lat: n,
                lng: w
            }, {
                lat: n,
                lng: e
            });

            let height = geospatialUtilities.haversineDistance({
                lat: n,
                lng: w
            }, {
                lat: s,
                lng: w
            });

            let ne = geospatialUtilities.shiftPoint({
                lat: n,
                lng: e
            }, -width, height);

            let sw = geospatialUtilities.shiftPoint({
                lat: s,
                lng: w
            }, width, -height);

            let getDataBounds = L.latLngBounds([ne.lat, ne.lng], [sw.lat, sw.lng]);

            setIsLoading(true);

            if (_getDataAbortController) {
                _getDataAbortController.abort()
            };

            _getDataAbortController = new AbortController();
            const signal = _getDataAbortController.signal;
            /* TODO: GET THE TIMEZONE OFFSET */

            api.getData(organisationId, projectId, selectedJobs, selectedUsers, distinctFilteredWorkflows, getDataBounds.getNorth(), getDataBounds.getSouth(), getDataBounds.getWest(), getDataBounds.getEast(), dateFrom, dateTo, 0, 0, 0, false, pageNumber, includeDeleted, signal, (data) => {

                const seen = new Set(basePointsArray.map(p => p.id));
                const deduped = data.items.filter(p => {
                    if (seen.has(p.id)) return false;
                    seen.add(p.id);
                    return true;
                });
                let newPoints = [...basePointsArray, ...deduped];

                if (pageNumber < pages) {      
                    getData(refresh, pageNumber + 1, pages, newPoints);
                }
                else {
                        
                    setPoints(newPoints);
                    setLines(arrayUtilities.distinct(newPoints.filter(x => x.lineId !== null).map(x => x.lineId)))
                    
                    setHiddenDataPoints(Math.max(0, data.totalCount - newPoints.length));
                    findTransferEligiblePoints(newPoints, workflowPoints, workflowLines, workflowPointsLines, theBounds)
                    setIsLoading(false);
                    setDataBounds(getDataBounds);
                }

            }, () => {
                if (signal.aborted) {
                    return;
                }
                setPoints(null);
                setLines(null);
                setIsLoading(false);
                setHiddenDataPoints(0)
            });
        }
    }

    const refreshSketches = function (selectSketchId) {
        api.getSketches(organisationId, projectId, (sketches) => {
            setSketches(sketches);
            setIsLoading(false);

            if (!stringUtilities.isNullOrEmpty(selectSketchId)) {
                setSketchId(selectSketchId);
            }
        })
    }

    const onSaveSketch = function (sketch, refresh) {
        
        sketch.configuration = {
            selectedJobs,
            dateFrom: dateFrom === null || stringUtilities.isNullOrEmpty(String(dateFrom)) ? null : dateFrom,
            dateTo: dateTo === null || stringUtilities.isNullOrEmpty(String(dateTo)) ? null : dateTo,
            points: workflowPoints,
            lines: workflowLines,
            pointsLines: workflowPointsLines,
            arrowScale: arrowScale,
            symbolScale: symbolScale,
            symbolDensity: symbolDensity,
            data: sketchData,
            zoom: zoomLocked ? zoom : null,
            selectedKmlIds: selectedKmlData
        };

        api.saveSketch(organisationId, projectId, sketchId, sketch, (data) => {

            if (data.isError) {
                setShowSketchSaveError(true);
                setSketchFromFailedSave(sketch);
            }
            else {
                setSketch(data);
                setSketchFromFailedSave(null);
                if (refresh) {
                    setSketchHash(hash(data));
                }
            }
        
        }, () => { })
    }

    const onSaveData = function (dataItem) {

        let newSketchData = [dataItem];

        if (!arrayUtilities.isNullOrEmpty(sketchData)) {

            let index = sketchData.findIndex(x => x.id === dataItem.id);
            if (index >= 0) {
                let copy = cloneDeep(sketchData);
                copy.splice(index, 1, dataItem);
                newSketchData = copy;

            } else {
                newSketchData = sketchData.concat([dataItem]);
            }
        }

        if (!sketch.configuration || sketch.configuration === null) {
            sketch.configuration = { data: newSketchData };
        } else {
            sketch.configuration.data = newSketchData;
        }

        api.saveSketch(organisationId, projectId, sketchId, sketch, () => {

        }, () => { })

        setSketchData(newSketchData);
    }

    const deleteSketch = function () {
        if (!stringUtilities.isNullOrEmpty(sketchId)) {
            setIsLoading(true);

            api.deleteSketch(organisationId, projectId, sketchId, () => {
                setSketches(sketches.filter(x => x.id !== sketchId));
                setSketchId(null);

                setIsLoading(false);
            }, () => {

                setIsLoading(false);
            });
        }
    }

    const refreshSelectedWorkflowLayers = function (sketch) {
        let allWorkflows = workflows?.map((x) => x.id);
        if (sketch && sketch !== null && sketch.configuration && sketch.configuration !== null) {

            if (arrayUtilities.isNullOrEmpty(sketch.configuration.points) && arrayUtilities.isNullOrEmpty(sketch.configuration.lines) && arrayUtilities.isNullOrEmpty(sketch.configuration.pointsLines)) {
                setWorkflowPoints(allWorkflows);
                setWorkflowLines(allWorkflows);
                setWorkflowPointsLines([]);
            } else {
                setWorkflowPoints(sketch.configuration.points);
                setWorkflowLines(sketch.configuration.lines);
                setWorkflowPointsLines(sketch.configuration.pointsLines);
            }

            if (sketch.configuration?.arrowScale === 0) {
                setArrowScale(1);
            } else {
                setArrowScale(sketch.configuration?.arrowScale ?? 1);
            }

            if (sketch.configuration?.symbolScale === 0) {
                setSymbolScale(1);
            } else {
                setSymbolScale(sketch.configuration?.symbolScale ?? 1);
            }
        } else {

            setWorkflowPoints(allWorkflows);
            setWorkflowLines(allWorkflows);
            setWorkflowPointsLines([]);
        }
    }

    //todo: move this to somewhere common, and probably use something better than window.timerid.
    const debounce = (fn, delay) => {
        return (...args) => {
            clearTimeout(window.timerId);
            window.timerId = setTimeout(() => {
                fn(...args);
            }, delay);
        }
    };

    const debounceGetData = useCallback(
        debounce(() => { 
            setPage(1);
            getData(false, 1, 1, []);
        }, 1500),
        [getData]
    );

    const debounceGetDataAndRefresh = useCallback(
        debounce(() => { 
            setPage(1);
            getData(true, 1, 1, []);
        }, 1500),
        [getData]
    );

    useEffect(() => {
        debounceGetData();
    }, [bounds])


    useEffect(() => {       
        debounceGetDataAndRefresh();
    }, [selectedJobs, selectedUsers, dateFrom, dateTo, distinctFilteredWorkflows, includeDeleted])

    useEffect(() => {
        if (workflowPoints !== undefined && workflowLines !== undefined && workflowPointsLines !== undefined) {
            setDistinctFilteredWorkflows(arrayUtilities.distinct([...workflowPoints, ...workflowLines, ...workflowPointsLines]))
        }
    }, [workflowPoints, workflowLines, workflowPointsLines])

    const checkIfAllTemplateIdsAreSame = (workflowsArray) => {

        const temp = workflowsArray[0].workflowTemplateId;

        if (stringUtilities.isNullOrEmpty(temp)) {
            return false
        };

        // TODO turn the every into a utility function after main tasks are finished
        return workflowsArray.every(item => item.workflowTemplateId === temp);
    }

    const findTransferEligiblePoints = (points, workflowPoints, workflowLines, workflowPointsLines, bounds) => {
        let _transferEligiblePoints = [];
        let _isMultiTransferEnabled = false;

        if (points != null) {
            const pointsVisibleWithinMapBounds = points.filter(item => bounds.contains([item.lat, item.lng]))
            const pointsWorkflowIds = pointsVisibleWithinMapBounds
                .map(item => item.workflowId)
            const uniqueWorkflowIds = arrayUtilities.distinct(pointsWorkflowIds);
            const filteredWorkflows = workflows?.filter(item => {
                if (uniqueWorkflowIds.includes(item.id) && (
                    (!arrayUtilities.isNullOrEmpty(workflowPoints) && workflowPoints.includes(item.id)) ||
                    (!arrayUtilities.isNullOrEmpty(workflowLines) && workflowLines.includes(item.id)) ||
                    (!arrayUtilities.isNullOrEmpty(workflowPointsLines) && workflowPointsLines.includes(item.id))
                )) return item
            })
            setFilteredWorkflows(filteredWorkflows)
            if (!arrayUtilities.isNullOrEmpty(filteredWorkflows) && checkIfAllTemplateIdsAreSame(filteredWorkflows)) {

                const filteredWorkflowsIds = filteredWorkflows.map(item => item.id)
                _transferEligiblePoints = pointsVisibleWithinMapBounds.filter(
                    item => {
                        if (
                            filteredWorkflowsIds.includes(item.workflowId)
                            && (item.userId === props.user.id || roleUtilities.hasOrgAdminCapability(props.user))
                        ) {
                            return item
                        }
                    }
                )
                if (!arrayUtilities.isNullOrEmpty(_transferEligiblePoints)) {
                    _isMultiTransferEnabled = true;
                }
                setWorkflowsForMove(filteredWorkflows)
            }
        }
        setTransferEligiblePoints(_transferEligiblePoints);
        setIsMultiTransferEnabled(_isMultiTransferEnabled);
    }

    useEffect(() => {
        setPointsHash(hash(points));
        findTransferEligiblePoints(points, workflowPoints, workflowLines, workflowPointsLines, bounds)
    }, [points]);

    useEffect(() => {
        refreshSelectedWorkflowLayers(sketch);
    }, [workflows])

    useEffect(() => {
        localStorage.setItem("printBasemap", printBasemap);
    }, [printBasemap])


    useEffect(() => {
        localStorage.setItem("basemap", basemap);
    }, [basemap])

    useEffect(() => {
        localStorage.setItem("mapOutputFormat", mapOutputFormat);
    }, [mapOutputFormat])

    useEffect(() => {
        localStorage.setItem("symbolDensity", symbolDensity);
    }, [symbolDensity])

    useEffect(() => {
        localStorage.setItem("cpmDrawingOrder", cpmDrawingOrder);
    }, [cpmDrawingOrder])

    useEffect(() => {
        postal.publish({
            channel: "map",
            topic: (zoomLocked ? "zoom.disabled" : "zoom.enabled")
        });

        if (sketch && sketch !== null) {
            onSaveSketch(sketch, false);
        }
    }, [zoomLocked]);

    useEffect(() => {

        setSketchData(null);

        if (!stringUtilities.isNullOrEmpty(sketchId)) {
            setIsLoading(true);
            api.getSketch(organisationId, projectId, sketchId, (data) => {
                setSketch(data);
                setSketchHash(hash(data));
                setIsLoading(false);

                if (data && data !== null && data.configuration && data.configuration !== null) {
                    setSelectedJobs(data.configuration.selectedJobs);
                    setDateFrom(data.configuration.dateFrom);
                    setDateTo(data.configuration.dateTo);
                    setSketchData(data.configuration.data);
                    setArrowScale(data.configuration?.arrowScale ?? 1);
                    setSymbolDensity(data.configuration.symbolDensity ?? 1)
                    if ((data.configuration?.zoom ?? 0) > 0) {
                        setZoom(data.configuration.zoom);
                        setZoomLocked(true);
                    } else {
                        setZoomLocked(false);
                    }
                } else {
                    setZoomLocked(false);
                }

                refreshSelectedWorkflowLayers(data);

                postal.publish({
                    channel: "map",
                    topic: "sketch.loaded",
                    data: {
                        sketch: data
                    }
                });
            }, () => {

            })
        } else {
            setSketch(null);
            setSketchHash(null);
            setZoomLocked(false);
        }
    }, [sketchId])

    useEffect(() => {

        const subscriptions = [
            postal.subscribe({
                channel: "map",
                topic: "zoom.changed",
                callback: function (data) {
                    setZoom(data.zoom);
                }
            }),
            postal.subscribe({
                channel: "map",
                topic: "isDrawingOrEditing",
                callback: function (data) {
                    isDrawingOrEditingRef.current = data.value;
                }
            })
        ]

        api.getProject(organisationId, projectId, (data) => {
            setProject(data);
            setSelectedProjectForMove(data.id);
            postal.publish({
                channel: "map",
                topic: "project.loaded",
                data: {
                    project: data
                }
            });

            setIsLoading(false);
        }, (error) => {
            setIsLoading(false);
        })

        api.getJobs(organisationId, projectId, (data) => {
            setJobs(data);
            setJobsForMove(data);
        })

        api.getSketches(organisationId, projectId, (data) => {
            setSketches(data);
        })

        api.getWorkflows(organisationId, projectId, (data) => {
            setWorkflows(data);
            setWorkflowsForMove(data);
        })

        api.getUsers(organisationId, true, (data) => {
            setUsers(data);
        })

        api.getStamps(organisationId, (data) => {
            setStamps(data);
        })

        api.getTags(organisationId, (data) => {
            setTags(data);
        })

        api.getProjects(organisationId, (data) => {
            setProjects(data);
        })

        api.getSurfaces(
            organisationId, projectId,
            data => {
                setSurfacesData(data);
                setSelectedSurfacesData(data.map(item => item.id));
                setIsSelectAllSurfacesChecked(true);
            },
            error => console.log(error)
        )

        api.getKmlFiles(
            organisationId, projectId,
            data => {
                const fetchKmlData = async () => {
                    const promises = data.map(
                        item => fetch(item.url)
                            .then(res => res.text())
                            .then(text => {

                                if (text.indexOf("http://") > -1) {
                                    text = text.replace(/http:\/\//g, "https://")
                                }

                                const parser = new DOMParser();
                                const kml = parser.parseFromString(text, "text/xml");

                                return { ...item, kml };
                            })
                    )

                    try {
                        const result = await Promise.all(promises);
                        setKmlData(result);
                        setSelectedKmlData(result.map(item => item.id));
                    } catch (error) {
                        console.log(error)
                    }
                }
                fetchKmlData();
            },
            error => console.log(error),
        )


        return () => {
            subscriptions.forEach(subscription => {
                subscription.unsubscribe();
            });
        }
    }, []);

    // Restore KML selection from sketch config when sketch or kmlData changes.
    useEffect(() => {
        if (!sketch || arrayUtilities.isNullOrEmpty(kmlData)) {
            return;
        }
        const savedIds = sketch.configuration?.selectedKmlIds;
        setSelectedKmlData(savedIds ?? kmlData.map(item => item.id));
    }, [sketch?.id, kmlData]);

    const containerStyle = {
        width: '100%',
        height: '100%'
    };

    const takeScreenshot = async function () {
        try {
            const mapNode = document.querySelector(".map-container .leaflet-container");
            const mapContainer = document.querySelector(".map-container");
            if (mapContainer) {
                mapContainer.classList.add("is-printing")
                if (mapOutputFormat === enums.MapOutputFormat[1]) {
                    mapContainer.classList.add("is-printing-png")
                }
            }
            return new Promise(resolve => setTimeout(async () => {
                if (mapOutputFormat === enums.MapOutputFormat[1]) {
                    await (htmlToImage.toPng(mapNode, { quality: 1 }).then(function (dataUrl) {
                        mapContainer.classList.remove("is-printing", "is-printing-png")
                        return resolve(dataUrl);
                    }));
                } else {
                    await (htmlToImage.toJpeg(mapNode, { quality: 1 }).then(function (dataUrl) {
                        mapContainer.classList.remove("is-printing")
                        return resolve(dataUrl);
                    }));
                }
                return resolve();

            }, 1000));
        }
        catch (e) {
            console.log(e);
        }
    }

    const onDownloadMapPackage = () => {
        if (!stringUtilities.isNullOrEmpty(sketchId)) {
            setShowMapPackagePanel(true);
        }
    }


    const downloadScreenshot = () => {

        setIsDownloadingScreenshot(true);

        setTimeout(() => {

            takeScreenshot().then(result => {
                const link = document.createElement("a");
                link.href = result;
                link.download = `map-${moment().format("YYYYMMDD-HHmmss")}.${mapOutputFormat}`;
                link.click();

                setIsDownloadingScreenshot(false);
            });
        }, 3000);

    }

    const onSavePointAttributes = (data, pointId, workflowId, applyToLine = true) => {
        api.updatePointAttributes(
            organisationId, projectId, null, pointId, workflowId, data, null, null, null, null, null,
            result => {
                if (result.isError) {
                    setUpdateFeatureAttributesError(result.errorMessage);
                } else {
                    setUpdateFeatureAttributesError(false);
                    // The API also updates the other vertices of a line: all of the Form Data, or just the Type when applied to a single point.
                    setPoints(points.map(item => {
                        if (item.id === result.id) {
                            return result;
                        }
                        if (result.lineId && item.lineId === result.lineId) {
                            let formData = item.formData;
                            if (applyToLine) {
                                formData = result.formData;
                            } else if (result.formData?.Type !== undefined) {
                                formData = { ...item.formData, Type: result.formData.Type };
                            }
                            return { ...item, workflowId: result.workflowId, formData };
                        }
                        return item;
                    }))
                }
            },
            () => { },
            applyToLine
        )
    }

    const onMovePointData = (currentProjectId, pointId, selectedProject, selectedJob, selectedWorkflow, data) => {
        api.updatePointAttributes(
            organisationId, currentProjectId, selectedProject, pointId, selectedWorkflow, data, selectedJob, null, null, null, null,
            result => {
                if (result.isError) {
                    setUpdateFeatureAttributesError(result.errorMessage);
                } else {
                    setUpdateFeatureAttributesError(false);
                    getData(true, 1, page, []);
                    api.getJobs(organisationId, projectId, (data) => {
                        setJobs(data);
                        setJobsForMove(data);
                    })
                }
            },
            () => { }
        )
    }

    const handleProjectChange = (id) => {
        setSelectedProjectForMove(id)
        setSelectedWorkflowForMove("");
        setSelectedJobForMove(null);
        setIsLoadingJobs(true);
        setIsLoadingWorkflows(true);
        api.getWorkflows(
            organisationId, id,
            data => {
                const templateIdsFromCurrentFilteredWorkflows = filteredWorkflows.map(item => item.workflowTemplateId)
                setWorkflowsForMove(data.filter(
                    item => templateIdsFromCurrentFilteredWorkflows.includes(item.workflowTemplateId)
                ));
                setIsLoadingWorkflows(false)
            },
            error => { console.log(error); setIsLoadingWorkflows(false) }
        );
        api.getJobs(
            organisationId, id,
            data => { setJobsForMove(data); setIsLoadingJobs(false) },
            error => { console.log(error); setIsLoadingJobs(false) }
        )
    }

    const handleMultiPointsMove = () => {
        setIsLoading(true)
        api.moveMultiplePoints(
            organisationId, projectId,
            !arrayUtilities.isNullOrEmpty(transferEligiblePoints) && transferEligiblePoints.map(item => item.id),
            selectedWorkflowForMove, selectedJobForMove, selectedProjectForMove,
            data => {
                if (data.isError) {
                    setUpdateFeatureAttributesError(data.errorMessage);
                    setIsLoading(false);
                }
                else {
                    setIsLoading(false)
                    setShowConfigurationDialog(false)              
                    setSelectedProjectForMove(projectId)
                    setSelectedWorkflowForMove("");
                    setSelectedJobForMove(null);
                    getData(true, 1, page, []);
                }
            },
            error => {
                console.log(error);
                setUpdateFeatureAttributesError(error);
                setIsLoading(false);
            }
        );
    }

    const handleKmlFeatureClick = (kmlId, info, latlng) => {
        if (isDrawingOrEditingRef.current) {
            return;
        }

        // A fresh key per click remounts the popup, as Leaflet closes the previous one on preclick
        setSelectedKmlFeature({ key: Date.now(), kmlId, info, latlng });
    }

    const handleKmlSelectionUpdate = (e, kml) => {
        if (e.target.checked) {
            setSelectedKmlData(prevState => [...prevState, kml.id])
            if (!arrayUtilities.isNullOrEmpty(kmlData) && kmlData.length - selectedKmlData.length === 1) {
                setIsSelectAllChecked(true)
            }
        } else if (!e.target.checked) {
            const index = selectedKmlData.findIndex(item => item === kml.id)
            setSelectedKmlData(prevState => prevState.toSpliced(index, 1))

            if (isSelectAllChecked) {
                setIsSelectAllChecked(false)
            }
        }
    }

    const handleSurfaceSelectionUpdate = (e, surface) => {
        if (e.target.checked) {
            setSelectedSurfacesData(prevState => [...prevState, surface.id])
            if (!arrayUtilities.isNullOrEmpty(surfacesData) && surfacesData.length - selectedSurfacesData.length === 1) {
                setIsSelectAllSurfacesChecked(true)
            }
        } else if (!e.target.checked) {
            const index = selectedSurfacesData.findIndex(item => item === surface.id)
            setSelectedSurfacesData(prevState => prevState.toSpliced(index, 1))

            if (isSelectAllSurfacesChecked) {
                setIsSelectAllSurfacesChecked(false)
            }
        }
    }

    const handleKmlSelectAll = (e) => {
        setIsSelectAllChecked(!isSelectAllChecked)
        if (e.target.checked && !arrayUtilities.isNullOrEmpty(kmlData)) {
            setSelectedKmlData(kmlData.map(item => item.id))
        } else if (!e.target.checked) {
            setSelectedKmlData([])
        }
    }

    const handleSurfacesSelectAll = (e) => {
        setIsSelectAllSurfacesChecked(!isSelectAllSurfacesChecked)
        if (e.target.checked && !arrayUtilities.isNullOrEmpty(surfacesData)) {
            setSelectedSurfacesData(surfacesData.map(item => item.id))
        } else if (!e.target.checked) {
            setSelectedSurfacesData([])
        }
    }

    const getUniqueLineTypes = (workflowConfig) => {
        const typesLines = workflowConfig.types?.filter(item => item.geometryType === "Line")
        const types2Lines = workflowConfig.types2?.filter(item => item.geometryType === "Line")

        return types2Lines.reduce((acc, curr) => {
            if (acc.findIndex(item => item.name === curr.name) === -1) {
                acc.push(curr)
            }
            return acc
        }, typesLines)
    }

    const handleConnectClick = (point, pointId) => {
        if (!connectionOriginalPoint) {
            setConnectionOriginalPoint(point)
            const pointIndex = points.findIndex(item => item.id === pointId)
            if (pointIndex > -1) {
                const newArray = points.toSpliced(pointIndex, 1)
                setPoints(newArray)
            }
        } else {
            setConnectionTargetPoint(point)
            setIsConnectingPoints(true)
        }
        const workflow = workflows.find(item => item.id === point.workflowId)
        if (workflow !== undefined) {
            const parsedWorkflowConfig = JSON.parse(workflow.configuration)
            const uniqueLineTypes = getUniqueLineTypes(parsedWorkflowConfig)
            if (!connectionOriginalPoint) {
                setConnectionLineTypesOriginalPoint(
                    prevState => [
                        ...prevState,
                        ...uniqueLineTypes
                    ]
                )
            } else {
                setConnectionLineTypesTargetPoint(prevState => [
                    ...prevState,
                    ...uniqueLineTypes
                ])
            }

        }
    }

    const handlePointsConnectionConfirm = () => {
        if (selectedConnectionLineType) {
            api.createPoint(
                organisationId, projectId, 
                selectedConnectionLineType.workflowId,
                {...connectionOriginalPoint.formData, Type: selectedConnectionLineType.type.name},
                connectionOriginalPoint.jobId,
                connectionOriginalPoint.gpsData,
                connectionOriginalPoint.sensorData,
                connectionOriginalPoint.photos,
                connectionOriginalPoint.attachments,
                1,
                null,
                data => {
                    if (data.isError) {
                        setErrorMessage(data.errorMessage)
                        setConnectionOriginalPoint(null)
                        setConnectionTargetPoint(null)
                        setIsConnectingPoints(false)
                        setSelectedConnectionLineType(null)
                        setConnectionLineTypesOriginalPoint([])
                        setConnectionLineTypesTargetPoint([])
                    } else {
                        api.createPoint(
                            organisationId, projectId,
                            selectedConnectionLineType.workflowId,
                            { ...connectionTargetPoint.formData, Type: selectedConnectionLineType.type.name },
                            connectionTargetPoint.jobId,
                            connectionTargetPoint.gpsData,
                            connectionTargetPoint.sensorData,
                            connectionTargetPoint.photos,
                            connectionTargetPoint.attachments,
                            1,
                            data.lineId,
                            result => {
                                if (result.isError) {
                                    setErrorMessage(result.errorMessage)
                                    setIsConnectingPoints(false)
                                } else {
                                    setConnectionOriginalPoint(null)
                                    setConnectionTargetPoint(null)
                                    setIsConnectingPoints(false)
                                    setSelectedConnectionLineType(null)
                                    setConnectionLineTypesOriginalPoint([])
                                    setConnectionLineTypesTargetPoint([])
                                    getData(true, 1, page, [])
                                }
                            },
                            error => {
                                console.log(error)
                                setErrorMessage(error.message)
                                setConnectionOriginalPoint(null)
                                setConnectionTargetPoint(null)
                                setIsConnectingPoints(false)
                                setSelectedConnectionLineType(null)
                                setConnectionLineTypesOriginalPoint([])
                                setConnectionLineTypesTargetPoint([])
                            }
                        )
                    }
                },
                error => {
                    console.log(error)
                    setErrorMessage(error.message)
                    setConnectionOriginalPoint(null)
                    setConnectionTargetPoint(null)
                    setIsConnectingPoints(false)
                    setSelectedConnectionLineType(null)
                    setConnectionLineTypesOriginalPoint([])
                    setConnectionLineTypesTargetPoint([])
                }

            )
        }
    }
    const sortByTypeName = (a, b) => {
		const nameA = a.name.toUpperCase()
		const nameB = b.name.toUpperCase()
		if (nameA < nameB) {
			return -1;
		}
		if (nameA > nameB) {
			return 1;
		}
		return 0;
	}

    const renderWorkflowOptionsForConnection = (originalPoint, targetPoint) => {
        if (originalPoint.workflowId !== targetPoint.workflowId) {
            return [
                {
                    point: connectionOriginalPoint,
                    lineTypes: connectionLineTypesOriginalPoint,
                },
                {
                    point: connectionTargetPoint,
                    lineTypes: connectionLineTypesTargetPoint
                }
            ].sort((a, b) => {
                    const nameA = a.point.workflow.toUpperCase()
                    const nameB = b.point.workflow.toUpperCase()
                    if (nameA < nameB) {
                        return -1;
                    }
                    if (nameA > nameB) {
                        return 1;
                    }
                    return 0;
                })
        } else {
            return [
                {
                    point: connectionOriginalPoint,
                    lineTypes: connectionLineTypesOriginalPoint,
                }
            ]
        }
        
    }

    const handleUnDelete = (point) => {
        setIsLoading(true);
        api.unDeletePoint(
            organisationId, projectId, point.id, 
            data => {
                if (data.isError) {
                    setErrorMessage(data.errorMessage)
                    setIsLoading(false);
                } else {
                    getData(true, 1, page, [])
                    setIsLoading(false)
                }
            },
            error => {
                console.log(error)
                setIsLoading(false)
                setErrorMessage(error.errorMessage)
            }
        )
    }

    const handleDelete = (pointId, deleteMode) => {
        setIsLoading(false);
        api.deletePoint(
            organisationId, projectId, pointId, deleteMode, 
            data => {
                if (data.isError) {
                    setErrorMessage(data.errorMessage)
                } else {
                    getData(true, 1, page, [])
                    setIsLoading(false)
                }
            }, 
            error => {
                console.log(error)
                setIsLoading(false)
                setErrorMessage(error.errorMessage)
            }
        )
    }

    const handleUnDeleteGeometry = (geometryId) => {
        api.unDeleteGeometry(
            props.organisationId, projectId, geometryId, 
            data => {
                if (data.isError) {
                    setErrorMessage(data.errorMessage)
                    setIsLoading(false);
                } else {
                    getData(true, 1, page, [])
                    setIsLoading(false)
                }
            },
            error => {
                console.log(error)
                setIsLoading(false)
                setErrorMessage(error.errorMessage)
            }
        )
    }

    return <>
        <div className='sketch-wrapper'>
            <div className='sketch-filters px-3 py-3'>
                <SimpleBar autoHide={false} className='simplebar-no-autohide map-toolbox' style={{ maxHeight: '100%' }}>
                    <div className='d-flex'>
                        <h1 className="h5">{project?.name}</h1>
                    </div>

                    <Form.Group controlId='input-small' className='mx-1 d-flex align-items-center'>
                        <Form.Label className='me-0 mb-0 me-3 pe-1 text-nowrap'>
                            Zoom:
                        </Form.Label>
                        <ReactSlider disabled={zoomLocked} className='range-slider range-slider-single' thumbClassName='range-slider-handle' trackClassName='range-slider-track' min={0} max={MaxZoom} value={zoom} ariaLabel={['Handle']} ariaValuetext={state => `Handle value ${state.valueNow}`} step={0.1} onAfterChange={onAfterZoomChange} onChange={onZoomChange} renderThumb={(props, state) => (
                            <div {...props}>
                                <div className='range-slider-tooltip'>{state.valueNow}</div>
                            </div>
                        )} />

                        {zoomLocked && sketch && sketch !== null && <OverlayTrigger rootClose placement='bottom' trigger='click' overlay={
                            <Popover>
                                <Popover.Header as='h3'>Zoom Lock</Popover.Header>
                                <Popover.Body style={{ minWidth: "275px" }}>

                                    <label class="text-body fs-sm me-0 pe-1 text-nowrap form-label">Override</label>
                                    <ReactSlider className='range-slider range-slider-single mb-5' thumbClassName='range-slider-handle' trackClassName='range-slider-track' min={0} max={MaxZoom} value={zoom} ariaLabel={['Handle']} ariaValuetext={state => `Handle value ${state.valueNow}`} step={0.1} onAfterChange={onAfterZoomChange} onChange={onZoomChange} renderThumb={(props, state) => (
                                        <div {...props}>
                                            <div className='range-slider-tooltip'>{state.valueNow}</div>
                                        </div>
                                    )} />

                                    <div class="d-flex align-items-center justify-content-between mt-4">
                                        <Button variant='secondary btn-icon' size="sm" className='px-3' onClick={resetToLockedZoom}><i className='fi-rotate-left' /></Button>
                                        <Button variant='danger' size="sm" className='px-3' onClick={() => setZoomLocked(false)}><i className='fi-lock me-2' /> Unlock zoom</Button>
                                    </div>
                                </Popover.Body>
                            </Popover>
                        }>
                            <Button variant='danger btn-icon shadow-sm' size="sm" className='ms-3 px-3' ><i className='fi-lock' /></Button>
                        </OverlayTrigger>
                        }
                        {(!zoomLocked || !sketch || sketch === null) &&
                            <Button variant='success btn-icon shadow-sm' size="sm" className='ms-3 px-3' onClick={() => setZoomLocked(true)} disabled={!sketch || sketch === null}><i className='fi-unlock' /></Button>
                        }

                    </Form.Group>

                    <Accordion>
                        <AddressSearchToolbox />
                        <FiltersToolbox
                            jobs={jobs} selectedJobs={selectedJobs} onJobsSelected={setSelectedJobs}
                            users={users} selectedUsers={selectedUsers} onUsersSelected={setSelectedUsers}
                            workflows={workflows} workflowPoints={workflowPoints} onWorkflowPointsSelected={setWorkflowPoints} workflowLines={workflowLines} onWorkflowLinesSelected={setWorkflowLines} workflowPointsLines={workflowPointsLines} onWorkflowPointsLinesSelected={setWorkflowPointsLines}
                            dateFrom={dateFrom} onDateFromSelected={setDateFrom} dateTo={dateTo} onDateToSelected={setDateTo} isMultiTransferEnabled={isMultiTransferEnabled} onMoveDataClick={() => setShowConfigurationDialog(true)} includeDeleted={includeDeleted} setIncludeDeleted={setIncludeDeleted} />
                        {
                            !arrayUtilities.isNullOrEmpty(kmlData) && selectedKmlData &&
                            <KmlToolbox
                                kmlData={kmlData}
                                handleSelectAll={e => handleKmlSelectAll(e)}
                                handleSelectionUpdate={(e, item) => handleKmlSelectionUpdate(e, item)}
                                isSelectAllChecked={isSelectAllChecked}
                                selectedKmlData={selectedKmlData}
                            />
                        }
                        {
                            !arrayUtilities.isNullOrEmpty(surfacesData) && selectedSurfacesData &&
                            <SurfacesToolbox
                                handleSelectAllSurfaces={e => handleSurfacesSelectAll(e)}
                                handleSurfacesSelectionUpdate={(e, item) => handleSurfaceSelectionUpdate(e, item)}
                                isSelectAllSurfacesChecked={isSelectAllSurfacesChecked}
                                selectedSurfacesData={selectedSurfacesData}
                                surfacesData={surfacesData}
                            />
                        }
                        <SketchesToolbox projectId={projectId} organisationId={organisationId} sketches={sketches} sketchId={sketchId} sketch={sketch} key={hash({ sketches, sketchId, sketch })} onSketchSelected={setSketchId} onSketchDeleted={deleteSketch} onRefreshSketches={refreshSketches} user={props.user} />
                        <LimitsToolbox sketch={sketch} activeLimit={activeLimit} onActiveLimitSelected={setActiveLimit} />
                        <DrawingToolsToolbox sketch={sketch} />
                        <StampsToolbox sketch={sketch} stamps={stamps} tags={tags} />
                        <MapOutputToolbox isSendingMapPackage={showMapPackagePanel} sketch={sketch} workflows={workflows} onDownloadData={setIsDownloadingData} organisationId={organisationId} onDownloadMapPackage={onDownloadMapPackage} onDownloadScreenshot={() => downloadScreenshot()} onDownloadTelusReport={() => setIsDownloadingTelusReport(true)} onDownloadOntarioLocateReport={() => setIsDownloadingOntarioLocateReport(true)} />
                        <DownloadsToolbox organisationId={organisationId} projectId={projectId} refreshKey={downloadsRefreshKey} />
                        <SettingsToolbox
                            basemap={basemap} onBasemapChange={setBasemap}
                            printBasemap={printBasemap} onPrintBasemapChange={setPrintBasemap}
                            mapOutputFormat={mapOutputFormat}
                            onFormatChange={setMapOutputFormat}
                            snappingTolerance={snappingTolerance} onSnappingToleranceChange={setSnappingTolerance}
                            arrowScale={arrowScale} onArrowScaleChange={setArrowScale} onAfterArrowScaleChange={onAfterArrowScaleChange}
                            symbolScale={symbolScale} onSymbolScaleChange={setSymbolScale}
                            symbolDensity={symbolDensity} onSymbolDensityChange={setSymbolDensity}
                            cpmDrawingOrder={cpmDrawingOrder} onCpmDrawingOrderChange={setCpmDrawingOrder}
                            center={center} />
                        </Accordion>
                    </SimpleBar>
            </div>
            <div className="map-container d-flex flex-column align-items-center">
                <MapContainer center={center} zoom={zoom} style={containerStyle} dragging={true} maxZoom={MaxZoom} ref={mapRef} zoomSnap={0.1} zoomDelta={0.1}>
                    <RemoteControl onBoundsChange={onBoundsChange} onZoomChange={setZoom} />
                    <BufferOrdering cpmDrawingOrder={cpmDrawingOrder} />
                    <Basemap tileLayerRef={tileLayerRef} basemap={isDownloadingScreenshot ? printBasemap : basemap} zoom={zoom} isDownloadingMapPackage={isDownloadingScreenshot} maxZoom={MaxZoom} />

                    <Pane name={BUFFER_PANE} style={{ zIndex: BUFFER_PANE_Z_INDEX }} />
                    <Pane name="dimension-line-icons" style={{ zIndex: 5000 }} />
                    <Pane name="drawing-tool-labels" style={{ zIndex: 5001 }} />

                    {
                        !arrayUtilities.isNullOrEmpty(surfacesData) && selectedSurfacesData &&
                        surfacesData.filter(item => selectedSurfacesData.includes(item.id)).map(
                            item => <Surface
                                key={item.id}
                                surfaceDataObject={item}
                            />
                        )
                    }
                    {
                        !arrayUtilities.isNullOrEmpty(kmlData) &&
                        !arrayUtilities.isNullOrEmpty(selectedKmlData) &&
                        kmlData.filter(item => selectedKmlData.includes(item.id)).map(item => <KmlLayer key={item.id} kml={item.kml} onFeatureClick={(info, latlng) => handleKmlFeatureClick(item.id, info, latlng)} />)
                    }
                    {
                        selectedKmlFeature && selectedKmlData.includes(selectedKmlFeature.kmlId) &&
                        <WhenMapIsNotDrawingOrEditing>
                            <KmlPopup
                                key={selectedKmlFeature.key}
                                info={selectedKmlFeature.info}
                                latlng={selectedKmlFeature.latlng}
                                onClose={() => setSelectedKmlFeature(current => current?.key === selectedKmlFeature.key ? null : current)} />
                        </WhenMapIsNotDrawingOrEditing>
                    }
                    {!arrayUtilities.isNullOrEmpty(lines) && <> {lines.map((lineId, index) => <DataGeomtry index={index} key={`line-${lineId}-${pointsHash}`} user={props.user} organisationId={organisationId} jobs={jobs} projects={projects} projectId={projectId} lineId={lineId} points={points} lines={lines} workflows={workflows} workflowLines={workflowLines} sketch={sketch} symbolScale={symbolScale} snappingTolerance={snappingTolerance} onSave={onSaveData} onSavePointAttributes={(data, pointId, workflowId) => onSavePointAttributes(data, pointId, workflowId)} onMoveData={(projectId, pointId, selectedProject, selectedJob, selectedWorkflow, data) => onMovePointData(projectId, pointId, selectedProject, selectedJob, selectedWorkflow, data)} symbolDensity={symbolDensity} handleDelete={(pointId, deleteMode) => handleDelete(pointId, deleteMode)} handleUnDeleteGeometry={geometryId => handleUnDeleteGeometry(geometryId)} handleUnDeletePoint={pointId => handleUnDelete(pointId)} />)} </>}
                    {!arrayUtilities.isNullOrEmpty(points) && <> {points.map((point, index) => <DataPoint connectionOriginalPoint={connectionOriginalPoint} connectionTargetPoint={connectionTargetPoint}
                    handleConnectClick={detailedPoint => handleConnectClick(detailedPoint, point.id)} 
                    index={index} key={`point-${point.id}-${pointsHash}`} user={props.user} organisationId={organisationId} jobs={jobs} projects={projects} projectId={projectId} point={point} points={points} lines={lines} workflows={workflows} workflowPoints={workflowPoints} workflowPointsLines={workflowPointsLines} sketch={sketch} symbolScale={symbolScale} cpmDrawingOrder={cpmDrawingOrder} snappingTolerance={snappingTolerance} onSave={onSaveData} onMoveData={(projectId, pointId, selectedProject, selectedJob, selectedWorkflow, data) => onMovePointData(projectId, pointId, selectedProject, selectedJob, selectedWorkflow, data)} onSavePointAttributes={(data, pointId, workflowId, applyToLine) => onSavePointAttributes(data, pointId, workflowId, applyToLine)} handleUnDelete={point => handleUnDelete(point)} handleDelete={(pointId, deleteMode) => handleDelete(pointId, deleteMode)} handleUnDeleteGeometry={geometryId => handleUnDeleteGeometry(geometryId)} />)} </>}
                    {sketch && sketch !== null &&
                        <Sketch
                            zoom={zoom}
                            sketch={sketch}
                            onSave={onSaveSketch}
                            key={sketchHash}
                            project={project}
                            workflows={workflows}
                            points={points}
                            lines={lines}
                            snappingTolerance={snappingTolerance}
                            workflowLines={workflowLines}
                            workflowPoints={workflowPoints}
                            workflowPointsLines={workflowPointsLines}
                            arrowScale={arrowScale}
                            symbolScale={symbolScale}
                            symbolDensity={symbolDensity}
                            stamps={stamps}
                            activeLimit={activeLimit} />
                    }

                    {isDownloadingData && isDownloadingData !== null &&
                        <DownloadData
                            includeDeleted={includeDeleted}
                            organisationId={organisationId}
                            projectId={projectId}
                            selectedJobs={selectedJobs}
                            selectedUsers={selectedUsers}
                            mapRef={mapRef}
                            dateFrom={dateFrom}
                            dateTo={dateTo}
                            workflows={distinctFilteredWorkflows}
                            exportFormat={isDownloadingData}
                            onComplete={() => {
                                setIsDownloadingData(null);
                                setDownloadsRefreshKey(key => key + 1);
                            }} />
                    }
                    {isDownloadingTelusReport &&
                        <DownloadTelusReport
                            sketch={sketch}
                            organisationId={organisationId}
                            projectId={projectId}
                            sketchId={sketchId}
                            basemap={printBasemap}
                            includeDeleted={includeDeleted}
                            selectedSurfaceIds={selectedSurfacesData}
                            onComplete={() => {
                                setIsDownloadingTelusReport(false);
                                setDownloadsRefreshKey(key => key + 1);
                            }} />
                    }
                    {isDownloadingOntarioLocateReport &&
                        <DownloadOntarioLocateReport
                            sketch={sketch}
                            workflows={workflows}
                            points={points}
                            workflowPoints={workflowPoints}
                            workflowLines={workflowLines}
                            workflowPointsLines={workflowPointsLines}
                            organisationId={organisationId}
                            projectId={projectId}
                            sketchId={sketchId}
                            basemap={printBasemap}
                            includeDeleted={includeDeleted}
                            selectedSurfaceIds={selectedSurfacesData}
                            onComplete={() => {
                                setIsDownloadingOntarioLocateReport(false);
                                setDownloadsRefreshKey(key => key + 1);
                            }} />
                    }
                </MapContainer>
                <div className='map-messages-container'>
                    {
                        hiddenDataPoints > 0 &&
                        <Alert variant='info' className='d-flex'>
                            <i className='fi-alert-circle me-2 me-sm-3 lead'></i>
                            <div className='d-flex align-items-center gap-2'>You are zoomed out too far, not all data displayed ({stringUtilities.formatDecimal(hiddenDataPoints, 0)} data points hidden).
                                <Alert.Link href='#' onClick={() => {
                                    getData(true, page + 1, page + 1, points)
                                    setPage(prevState => prevState + 1)
                                }}>Load more</Alert.Link> 
                                <Alert.Link href='#' onClick={() => onAfterZoomChange(zoom + 1)}>Zoom in</Alert.Link>
                            </div>
                        </Alert>
                    }
                </div>

                {showMapPackagePanel &&
                    <DownloadMapPackage
                        sketch={sketch}
                        workflows={workflows}
                        points={points}
                        workflowPoints={workflowPoints}
                        workflowLines={workflowLines}
                        workflowPointsLines={workflowPointsLines}
                        selectedSurfaceIds={selectedSurfacesData}
                        organisationId={organisationId}
                        projectId={projectId}
                        sketchId={sketchId}
                        basemap={printBasemap}
                        mapOutputFormat={mapOutputFormat}
                        includeDeleted={includeDeleted}
                        onComplete={() => {
                            setShowMapPackagePanel(false);
                            setDownloadsRefreshKey(key => key + 1);
                        }} />}

                {(isLoading || isDownloadingScreenshot) &&
                    <Loading blur />
                }
            </div>
        </div>
        <ConfigurationDialog
            show={showConfigurationDialog}
            title="Move all visible data"
            onSave={() => handleMultiPointsMove()}
            onCancel={() => {
                setShowConfigurationDialog(false);
                setSelectedProjectForMove(projectId);
                setSelectedJobForMove(null);
                setSelectedWorkflowForMove("");
            }
            }
            preventSave={stringUtilities.isNullOrEmpty(selectedJobForMove) || stringUtilities.isNullOrEmpty(selectedWorkflowForMove)}
        >
            <MoveData
                projects={projects}
                workflows={workflowsForMove}
                jobs={jobsForMove}
                selectedProject={selectedProjectForMove}
                selectedJob={selectedJobForMove}
                setSelectedJob={setSelectedJobForMove}
                selectedWorkflow={selectedWorkflowForMove}
                setSelectedWorkflow={setSelectedWorkflowForMove}
                onProjectChange={id => handleProjectChange(id)}
                onClickAddJob={() => setShowJobModal(true)}
                isLoadingJobs={isLoadingJobs}
                isLoadingWorkflows={isLoadingWorkflows}
                isLoading={isLoading}
            />
        </ConfigurationDialog>

        <Offcanvas show={isConnectingPoints} placement='end' scroll={false} backdrop={false}>
            <Offcanvas.Header className='border-bottom'>
                <Offcanvas.Title>Select line type</Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body>
                <div className="d-flex flex-align-start flex-column h-100 w-100 ">
                    <div className="w-100 h-100 mb-auto overflow-y-auto">
                        <SimpleBar autoHide={false} className='simplebar-no-autohide pe-3' style={{ maxHeight: 'calc(100vh - 280px)' }}>
                            {
                                connectionOriginalPoint && connectionTargetPoint &&
                                <>
                                    {
                                        arrayUtilities.isNullOrEmpty(connectionLineTypesOriginalPoint)
                                        && arrayUtilities.isNullOrEmpty(connectionLineTypesTargetPoint)
                                        ? <p>No Line types available</p>
                                        : renderWorkflowOptionsForConnection(connectionOriginalPoint, connectionTargetPoint).map(
                                    (connectionPoint, i) => 
                                        !arrayUtilities.isNullOrEmpty(connectionPoint.lineTypes) && 
                                        <div className='mb-4' key={i}>
                                        <p className="h6">{ connectionPoint.point.workflow }</p>
                                        {
                                            connectionPoint.lineTypes.sort(sortByTypeName).map(
                                                (item, index) => <Form.Check
                                                    id={ `${connectionPoint.point.workflow}-${ index }-connection-line-type-radio` }
                                                    type='radio'
                                                    name={ `${connectionPoint.point.workflow}-${ index }-connection-line-type-radio` }
                                                    checked={ selectedConnectionLineType && selectedConnectionLineType.workflowId === connectionPoint.point.workflowId && selectedConnectionLineType.type.name === item.name }
                                                    key={ index }
                                                    label={ item.name }
                                                    onChange={ e => setSelectedConnectionLineType({type: item, workflowId: connectionPoint.point.workflowId}) }
                                                />
                                            )
                                        }
                                    </div>
                                )
                                    }
                                </>
                            }
                        </SimpleBar>
                    </div>

                    <div className="d-flex justify-content-between order-2 w-100">
                        <Button size="sm" variant='secondary' onClick={() => {
                            setIsConnectingPoints(false)
                            setConnectionLineTypesOriginalPoint([])
                            setConnectionLineTypesTargetPoint([])
                            setConnectionOriginalPoint(null)
                            setConnectionTargetPoint(null)
                            setSelectedConnectionLineType(null)
                            getData(true, 1, page, [])
                        }}>Cancel</Button>
                        <Button disabled={(selectedConnectionLineType === null || (arrayUtilities.isNullOrEmpty(connectionLineTypesOriginalPoint)
                                        && arrayUtilities.isNullOrEmpty(connectionLineTypesTargetPoint)))} size="sm" variant="primary" onClick={() => handlePointsConnectionConfirm()}>Confirm</Button>
                    </div>
                </div>
            </Offcanvas.Body>
        </Offcanvas>

        <Modal show={!stringUtilities.isNullOrEmpty(updateFeatureAttributesError)} onHide={() => setUpdateFeatureAttributesError(null)} centered>
            <Modal.Header>
                <Modal.Title className="d-flex gap-2 align-items-center"><i className='fi-alert-triange text-danger' />Error</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p className='m-0'>{updateFeatureAttributesError}</p>
            </Modal.Body>
            <Modal.Footer>
                <Button size="sm" variant='secondary' onClick={() => setUpdateFeatureAttributesError(null)}>Close</Button>
            </Modal.Footer>
        </Modal>

        <Modal show={showJobModal} onCancel={() => setShowJobModal(false)} onHide={() => setShowJobModal(false)} onSave={() => { }} centered>
            <Modal.Header closeButton>
                <Modal.Title>Add Job</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <SimpleBar autoHide={false} className='simplebar-no-autohide pe-3' style={{ maxHeight: 'calc(100vh - 380px)' }}>
                    <Form.Group className='mb-3 row'>
                        <Form.Label className='form-label fs-sm col-form-label col-md-3' htmlFor="job-name">
                            Name
                        </Form.Label>
                        <div className="col-md-9 d-flex align-items-center">
                            <Form.Control id="job-name" size='sm' value={newJobName} type="text" onChange={(e) => setNewJobName(e.target.value)} />
                        </div>
                    </Form.Group>
                </SimpleBar>
            </Modal.Body>
            <Modal.Footer>
                <div>
                    <Button size="sm" variant='secondary' onClick={() => {
                        setNewJobName("");
                        setShowJobModal(false);
                    }} className="me-2">Cancel</Button>
                    <Button size="sm" variant='primary' onClick={() => {
                        setIsLoading(true)
                        api.addJob(
                            organisationId, selectedProjectForMove, newJobName,
                            data => {
                                setShowJobModal(false)
                                api.getJobs(organisationId, selectedProjectForMove, result => setJobsForMove(result), error => console.log(error))
                                setSelectedJobForMove(data.id)
                                setIsLoading(false)
                                setNewJobName("");
                            }
                        )
                    }}>Save</Button>
                </div>
            </Modal.Footer>
        </Modal>
        {!stringUtilities.isNullOrEmpty(errorMessage) && <ErrorModal error={{message: errorMessage}} onDismiss={() => setErrorMessage(null)} />}
        {showSketchSaveError && sketchFromFailedSave !== null &&
            <ErrorModal error={{ message: "Failed to save sketch" }} onDismiss={() => {
                setShowSketchSaveError(false); 
                setSketchFromFailedSave(null);
            }} onRetry={() => {
                onSaveSketch(sketchFromFailedSave, true);
                setShowSketchSaveError(false);
            }} />
        }
    </>;

}